/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3.49951 3.5L7.49997 7.50046M12.9999 11C12.9999 12.1046 12.1045 13 10.9999 13C9.89537 13 8.99994 12.1046 8.99994 11C8.99994 9.89543 9.89537 9 10.9999 9C12.1045 9 12.9999 9.89543 12.9999 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.999 19L18.999 14V10.3695C18.999 8.46035 18.999 7.50578 18.6533 6.72913C18.3485 6.04444 17.8574 5.45915 17.2361 5.03999C16.5314 4.56453 15.5913 4.39864 13.7112 4.06686L6.50089 2.79445C4.98642 2.52719 4.22919 2.39356 3.68376 2.62504C3.20654 2.82758 2.8266 3.20751 2.62407 3.68474C2.39258 4.23017 2.52621 4.9874 2.79347 6.50187L4.06589 13.7122C4.39767 15.5923 4.56355 16.5323 5.03901 17.2371C5.45818 17.8584 6.04346 18.3494 6.72815 18.6542C7.50481 19 8.45937 19 10.3685 19H13.999ZM14.999 22L21.499 15.5C22.0513 14.9477 22.0513 14.0523 21.499 13.5V13.5C20.9467 12.9477 20.0513 12.9477 19.499 13.5L12.999 20C12.4467 20.5523 12.4467 21.4477 12.999 22V22C13.5513 22.5523 14.4467 22.5523 14.999 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.999 19L18.999 14V10.3695C18.999 8.46035 18.999 7.50578 18.6533 6.72913C18.3485 6.04444 17.8574 5.45915 17.2361 5.03999C16.5314 4.56453 15.5913 4.39864 13.7112 4.06686L6.50089 2.79445C4.98642 2.52719 4.22919 2.39356 3.68376 2.62504C3.20654 2.82758 2.8266 3.20751 2.62407 3.68474C2.39258 4.23017 2.52621 4.9874 2.79347 6.50187L4.06589 13.7122C4.39767 15.5923 4.56355 16.5323 5.03902 17.2371C5.45818 17.8584 6.04346 18.3494 6.72815 18.6542C7.50481 19 8.45937 19 10.3685 19H13.999ZM11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13Z"
				fill="currentColor"
			/>
			<path
				d="M3.49951 3.5L7.49997 7.50046M13.999 19L18.999 14V10.3695C18.999 8.46035 18.999 7.50578 18.6533 6.72913C18.3485 6.04444 17.8574 5.45915 17.2361 5.03999C16.5314 4.56453 15.5913 4.39864 13.7112 4.06686L6.50089 2.79445C4.98642 2.52719 4.22919 2.39356 3.68376 2.62504C3.20654 2.82758 2.8266 3.20751 2.62407 3.68474C2.39258 4.23017 2.52621 4.9874 2.79347 6.50187L4.06589 13.7122C4.39767 15.5923 4.56355 16.5323 5.03901 17.2371C5.45818 17.8584 6.04346 18.3494 6.72815 18.6542C7.50481 19 8.45937 19 10.3685 19H13.999ZM13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11ZM12.999 20L19.499 13.5C20.0513 12.9477 20.9467 12.9477 21.499 13.5V13.5C22.0513 14.0523 22.0513 14.9477 21.499 15.5L14.999 22C14.4467 22.5523 13.5513 22.5523 12.999 22V22C12.4467 21.4477 12.4467 20.5523 12.999 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_6402)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.79006 5.13232C1.66305 4.41259 1.59955 4.05272 1.67749 3.88266C1.79185 3.63317 2.06092 3.49308 2.33089 3.54247C2.51491 3.57613 2.77331 3.83453 3.2901 4.35132L6.93927 8.00048C7.23216 8.29338 7.70703 8.29338 7.99993 8.00048C8.29282 7.70759 8.29282 7.23272 7.99993 6.93983L4.35129 3.29119C3.83471 2.7746 3.57641 2.51631 3.54272 2.33238C3.49325 2.06231 3.6334 1.79312 3.88302 1.67878C4.05302 1.6009 4.41275 1.66438 5.1322 1.79134L14.4965 3.44388C15.556 3.63083 16.0857 3.72431 16.5296 3.89352C18.1488 4.51066 19.333 5.92216 19.6594 7.62397C19.7489 8.09056 19.7489 8.62847 19.7489 9.70427C19.7489 10.1463 19.7489 10.3673 19.7262 10.5794C19.6445 11.3432 19.3446 12.0673 18.8623 12.6652C18.7284 12.8313 18.5721 12.9876 18.2596 13.3002L13.3004 18.26C12.9876 18.5728 12.8313 18.7292 12.6651 18.8632C12.0673 19.3456 11.3432 19.6455 10.5794 19.7273C10.3671 19.75 10.1459 19.75 9.70365 19.75C8.62738 19.75 8.08925 19.75 7.62246 19.6604C5.92096 19.334 4.50973 18.15 3.89256 16.5311C3.72324 16.087 3.62972 15.5571 3.44268 14.4972L1.79006 5.13232ZM12.9999 11C12.9999 12.1046 12.1044 13 10.9999 13C9.8953 13 8.99987 12.1046 8.99987 11C8.99987 9.89543 9.8953 9 10.9999 9C12.1044 9 12.9999 9.89543 12.9999 11Z"
					fill="currentColor"
				/>
				<path
					d="M19.7186 13.2197C20.4257 12.5126 21.5721 12.5126 22.2792 13.2197C22.9863 13.9267 22.9863 15.0732 22.2792 15.7803L15.2792 22.7803C14.5721 23.4874 13.4257 23.4874 12.7186 22.7803C12.0115 22.0732 12.0115 20.9268 12.7186 20.2197L19.7186 13.2197Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_6402">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19.0001 10.5L18.999 9.5V9.5C18.999 8.41847 18.999 7.87771 18.8863 7.41297C18.5919 6.19917 17.7473 5.19258 16.6032 4.69168C16.1651 4.4999 15.6326 4.40592 14.5675 4.21797L6.50089 2.79445C4.98642 2.52719 4.22919 2.39356 3.68376 2.62504C3.20654 2.82758 2.8266 3.20751 2.62407 3.68474C2.39258 4.23017 2.52621 4.9874 2.79347 6.50187L4.06589 13.7122C4.39767 15.5923 4.56355 16.5323 5.03901 17.2371C5.45818 17.8584 6.04346 18.3494 6.72815 18.6542C7.50481 19 8.45937 19 10.3685 19H11.3481C12.3264 19 12.8156 19 13.276 18.8895C13.6841 18.7915 14.0743 18.6299 14.4322 18.4106C14.8358 18.1632 15.1817 17.8173 15.8735 17.1255L19.499 13.5C20.0513 12.9477 20.9467 12.9477 21.499 13.5V13.5C22.0513 14.0523 22.0513 14.9477 21.499 15.5L15.999 21M3.49951 3.5L7.49997 7.50046M13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.49951 3.5L7.49997 7.50046M13.999 19L18.999 14V10.3695C18.999 8.46035 18.999 7.50578 18.6533 6.72913C18.3485 6.04444 17.8574 5.45915 17.2361 5.03999C16.5314 4.56453 15.5913 4.39864 13.7112 4.06686L6.50089 2.79445C4.98642 2.52719 4.22919 2.39356 3.68376 2.62504C3.20654 2.82758 2.8266 3.20751 2.62407 3.68474C2.39258 4.23017 2.52621 4.9874 2.79347 6.50187L4.06589 13.7122C4.39767 15.5923 4.56355 16.5323 5.03901 17.2371C5.45818 17.8584 6.04346 18.3494 6.72815 18.6542C7.50481 19 8.45937 19 10.3685 19H13.999ZM13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11ZM12.999 20L19.499 13.5C20.0513 12.9477 20.9467 12.9477 21.499 13.5V13.5C22.0513 14.0523 22.0513 14.9477 21.499 15.5L14.999 22C14.4467 22.5523 13.5513 22.5523 12.999 22V22C12.4467 21.4477 12.4467 20.5523 12.999 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M5.84106 2.18293L12.8035 3.27825C15.2634 3.66524 16.4934 3.85873 17.4072 4.46876C18.2123 5.00626 18.8441 5.76593 19.2258 6.65555C19.6591 7.66521 19.6251 8.90983 19.5573 11.3991L19.5 13.5L13.5 19.5L11.3993 19.5575C8.90958 19.6258 7.66473 19.6599 6.65488 19.2266C5.76511 18.8449 5.00531 18.213 4.46774 17.4077C3.85763 16.4938 3.66419 15.2636 3.27732 12.8032L2.1826 5.84111C1.95185 4.37363 1.83648 3.63989 2.06721 3.10737C2.26922 2.64116 2.6411 2.26931 3.10733 2.06733C3.63986 1.83664 4.37359 1.95207 5.84106 2.18293Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.03033 1.97016C2.73744 1.67726 2.26256 1.67726 1.96967 1.97016C1.67678 2.26305 1.67678 2.73793 1.96967 3.03082L6.46967 7.53082C6.76256 7.82371 7.23744 7.82371 7.53033 7.53082C7.82322 7.23793 7.82322 6.76305 7.53033 6.47016L3.03033 1.97016ZM11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13ZM22.2794 13.2197C21.5723 12.5126 20.4259 12.5127 19.7188 13.2197L12.7188 20.2198C12.0117 20.9269 12.0117 22.0733 12.7188 22.7804C13.4259 23.4875 14.5723 23.4875 15.2794 22.7804L22.2794 15.7804C22.9865 15.0733 22.9865 13.9268 22.2794 13.2197Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
